module.exports = __webpack_public_path__ + "img/small-2.71dfd9a3.jpg";